'use client';
import { createContext, useContext } from 'react';
export const OverlayStackingContext = createContext('legacy');
OverlayStackingContext.displayName = 'OverlayStackingContext';
export function useOverlayStackingMode() {
    return useContext(OverlayStackingContext);
}
export function useActivationOrderedOverlayStacking() {
    return useOverlayStackingMode() === 'activation-order';
}
//# sourceMappingURL=useOverlayStacking.js.map